/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { extendObservable } from 'mobx';
import { createResourceStoreHouse } from 'src/luis/core/stores/resourceStoreHouse';
import { ResourceStoreHouse } from 'src/luis/types/stores/core/ResourceStoreHouse';
import { FeatureStore } from 'src/luis/types/stores/features/FeatureStore';
import { FeatureStoreHouse } from 'src/luis/types/stores/features/FeatureStoreHouse';
import { SubtractStore } from 'src/luis/types/SubtractStore';

/**
 * A factory function for creating an feature store house,
 * which houses an array of feature stores.
 */
export const createFeatureStoreHouse = (): FeatureStoreHouse => {
    const resourcesStoreHouse = createResourceStoreHouse<FeatureStore>();

    const featureStoreHouse: SubtractStore<FeatureStoreHouse, ResourceStoreHouse<FeatureStore>> = {};

    return extendObservable(resourcesStoreHouse, featureStoreHouse, {}, { deep: false });
};
